import {create} from 'zustand';
import {DashboardUser} from '../models/user.model';

interface UserUIState {
  // Tab Management
  activeTab: 'list' | 'statistics' | 'roles' | 'permissions';
  setActiveTab: (tab: 'list' | 'statistics' | 'roles' | 'permissions') => void;

  // Modal States
  isAddUserModalOpen: boolean;
  isEditUserModalOpen: boolean;
  isRoleModalOpen: boolean;
  isPermissionsModalOpen: boolean;
  isRoleDetailsModalOpen: boolean;

  // Modal Actions
  openAddUserModal: () => void;
  closeAddUserModal: () => void;
  openEditUserModal: () => void;
  closeEditUserModal: () => void;
  openRoleModal: () => void;
  closeRoleModal: () => void;
  openPermissionsModal: () => void;
  closePermissionsModal: () => void;
  openRoleDetailsModal: () => void;
  closeRoleDetailsModal: () => void;

  // Selected Items
  selectedUser: DashboardUser | null;
  selectedRole: any | null;
  managingPermissionsRole: any | null;
  selectedPermission: any | null;

  // Selection Actions
  setSelectedUser: (user: DashboardUser | null) => void;
  setSelectedRole: (role: any | null) => void;
  setManagingPermissionsRole: (role: any | null) => void;
  setSelectedPermission: (permission: any | null) => void;

  // Form States
  hasNewUser: boolean;
  setHasNewUser: (hasNew: boolean) => void;

  // Search and Filters
  searchQuery: string;
  statusFilter: string;
  roleFilter: number;
  roleSearchQuery: string;

  // Filter Actions
  setSearchQuery: (query: string) => void;
  setStatusFilter: (status: string) => void;
  setRoleFilter: (roleId: number) => void;
  setRoleSearchQuery: (query: string) => void;
  clearFilters: () => void;

  // Utility Actions
  reset: () => void;
}

export const useUserUIStore = create<UserUIState>((set) => ({
  // Initial state
  activeTab: 'list',
  isAddUserModalOpen: false,
  isEditUserModalOpen: false,
  isRoleModalOpen: false,
  isPermissionsModalOpen: false,
  isRoleDetailsModalOpen: false,
  selectedUser: null,
  selectedRole: null,
  managingPermissionsRole: null,
  selectedPermission: null,
  hasNewUser: false,
  searchQuery: '',
  statusFilter: '',
  roleFilter: 0,
  roleSearchQuery: '',

  // Tab Management
  setActiveTab: (tab) => set({activeTab: tab}),

  // Modal Actions
  openAddUserModal: () => set({isAddUserModalOpen: true}),
  closeAddUserModal: () => set({isAddUserModalOpen: false}),
  openEditUserModal: () => set({isEditUserModalOpen: true}),
  closeEditUserModal: () => set({isEditUserModalOpen: false}),
  openRoleModal: () => set({isRoleModalOpen: true}),
  closeRoleModal: () => set({isRoleModalOpen: false}),
  openPermissionsModal: () => set({isPermissionsModalOpen: true}),
  closePermissionsModal: () => set({isPermissionsModalOpen: false}),
  openRoleDetailsModal: () => set({isRoleDetailsModalOpen: true}),
  closeRoleDetailsModal: () => set({isRoleDetailsModalOpen: false}),

  // Selection Actions
  setSelectedUser: (user) => set({selectedUser: user}),
  setSelectedRole: (role) => set({selectedRole: role}),
  setManagingPermissionsRole: (role) => set({managingPermissionsRole: role}),
  setSelectedPermission: (permission) => set({selectedPermission: permission}),

  // Form States
  setHasNewUser: (hasNew) => set({hasNewUser: hasNew}),

  // Filter Actions
  setSearchQuery: (query) => set({searchQuery: query}),
  setStatusFilter: (status) => set({statusFilter: status}),
  setRoleFilter: (roleId) => set({roleFilter: roleId}),
  setRoleSearchQuery: (query) => set({roleSearchQuery: query}),
  clearFilters: () => set({
    searchQuery: '',
    statusFilter: '',
    roleFilter: 0,
    roleSearchQuery: ''
  }),

  // Utility Actions
  reset: () => set({
    activeTab: 'list',
    isAddUserModalOpen: false,
    isEditUserModalOpen: false,
    isRoleModalOpen: false,
    isPermissionsModalOpen: false,
    isRoleDetailsModalOpen: false,
    selectedUser: null,
    selectedRole: null,
    managingPermissionsRole: null,
    selectedPermission: null,
    hasNewUser: false,
    searchQuery: '',
    statusFilter: '',
    roleFilter: 0,
    roleSearchQuery: ''
  })
}));
